import { createReducer } from '@reduxjs/toolkit';
import { initialProductState as initialState } from './state';
import * as actions from './action';
import { setNestedField } from '../utils';

export default createReducer(initialState(), (builder) => {
  builder
    .addCase(actions.setProduct, (state, { payload: { field, value } }) => {
      setNestedField(state, field, value);
    })
    .addCase(actions.resetProduct, (state) => {
      return initialState();
    });
});
